export const attributeFlexSettings = {
  flexSettings: {
    type: 'object',
    default: {
      xs: [],
      sm: [],
      md: [],
      lg: [],
      xl: [],
      xxl: [],
    },
  },
};
